export {default as LegendComponent} from './legend/LegendComponent.js';
export {default as TooltipComponent} from './tooltip/TooltipComponent.js';
export {default as StackedAreaComponent} from './stackedArea/StackedAreaComponent.js';

// export default {
//     LegendComponent,
//     TooltipComponent,
//     StackedAreaComponent,
// };



// WEBPACK FOOTER //
// ./src/charts/index.js